import { useEffect } from 'react'

import { isDeployed } from '@fourthwall/utils/dist/dev'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

import { useDashboardFeatureFlags } from '../../../components/utils/DashboardFeatureFlags'
import { useSaveVisitMutation } from './useSaveVisitMutation'

/**
 * Keycloak creator account is used in Core Dashboard, Memberships Supporter and Shop Renderer.
 * If the user goes to Memberships Supporter there is no way to detect that the user is logged in
 * or prefer to log in as a creator instead of a supporter in Memberships Supporter
 * This cookie is used to detect if the user visited Core Dashboard and redirect to Keycloak.
 */

export const useSaveVisit = () => {
  const { currentShop } = useCurrentShop()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { saveVisitMutation } = useSaveVisitMutation()

  useEffect(() => {
    const saveVisit = () => {
      if (!dashboardFeatureFlags.dashboardSaveVisit.enabled || !currentShop || !isDeployed()) return

      if (currentShop.baseUri === currentShop.internalBaseUri) {
        saveVisitMutation.mutate(`${currentShop.baseUri}/platform/core_dashboard/save_visit`)
      }

      if (currentShop.internalBaseUri !== currentShop.baseUri) {
        saveVisitMutation.mutate(`${currentShop.baseUri}/platform/core_dashboard/save_visit`)
        saveVisitMutation.mutate(
          `${currentShop.internalBaseUri}/platform/core_dashboard/save_visit`,
        )
      }
    }

    saveVisit()
  }, [currentShop, dashboardFeatureFlags.dashboardSaveVisit.enabled])
}
